import React, { useRef, Fragment } from 'react';
import { useSelector } from 'react-redux';
import AsideContent from './AsideContent';

const VariantInformationAside = () => {
    const { groups } = useSelector((state) => state.variantInformationContent);
    const asideRef = useRef({});
    const showInformationAside = (groupId) => {
        asideRef.current[groupId].toggleAside();
    };

    return (
        <Fragment>
            {groups && groups.map((group) => {
                return (
                    <Fragment key={group.htmlGroupId}>
                        <button className="product-detail__show-aside variant-information" onClick={() => showInformationAside(group.htmlGroupId)}>
                            <span>{group.name ?? group.groupId}</span>
                            <img src="/ui/images/arrow.svg" />
                        </button>
                        <AsideContent cssClass="variant-information-aside" ref={(ref) => (asideRef.current[group.htmlGroupId] = ref)} title={group.name}>
                            {group.productFields && group.productFields.map((item) => (
                                <div key={item.id}>
                                    <div><strong>{item.name ?? item.id}</strong>{': '}</div><span dangerouslySetInnerHTML={{ __html: item.value }}></span>
                                </div>
                            ))}
                        </AsideContent>
                    </Fragment>
                )
            })}
        </Fragment>
    );
};

export default VariantInformationAside;